/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from 'react';
import cx from 'classnames';
import { ellipsis } from 'ellipsed';

import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import {
  ContentTypeIcon,
  When,
  Icon,
  ImageListing,
} from '@redturtle/iovisit-theme/components';
import { flattenToAppURL } from '@plone/volto/helpers';

const Card = ({
  item,
  show_icon = true,
  show_thematic_area = true,
  show_item_description = true,
  image_size = 'm',
  isEditMode,
}) => {
  const itemClass = 'E' + item['UID'];
  let url = item.getURL || item['@id'] || null;

  useEffect(() => {
    const class_name =
      '.block.listing .listing-template.cards .' + itemClass + ' .card-title';

    if (document.querySelectorAll(class_name)?.length > 0) {
      ellipsis(class_name, 4, {
        responsive: true,
      });
    }
  }, [item]);

  return (
    <div className={`card-wrapper ${itemClass}`}>
      <UniversalLink
        item={!isEditMode ? item : null}
        href={isEditMode ? '#' : url ? flattenToAppURL(url) : null}
      >
        <div className="card-header-wrapper">
          <figure className={`size-${image_size}`}>
            <ImageListing item={item} />
          </figure>
          <div className="card-header-text">
            <div className="card-infos">
              <div className="card-infos-left">
                {show_icon && <ContentTypeIcon item={item} />}
                {show_thematic_area && item.thematic_area && (
                  <span>{item.thematic_area}</span>
                )}
              </div>
              <div className="card-infos-right">
                <Icon prefix="fas" icon="arrow-right" className="icon" />
              </div>
            </div>
            <div className="card-title">{item.title}</div>
          </div>
        </div>
      </UniversalLink>

      {(item.start || item.end) && (
        <When
          start={item.start}
          end={item.end}
          whole_day={item.whole_day}
          open_end={item.open_end}
          recurrence={item.recurrence}
          show_times={false}
          listing={true}
          className="card-subtitle"
        />
      )}

      {show_item_description && item.description && (
        <div className="card-body">{item.description}</div>
      )}
    </div>
  );
};

export default Card;
